module.exports = __webpack_public_path__ + "static/media/clamp.9cc8beb7.png";